import {
    customerCardAuthorizationDefaultValues,
    CustomerCardAuthorizationFormType,
    customerCardCommunicationDefaultValues,
    CustomerCardCommunicationFormType,
    customerCardDetailsDefaultValues,
    CustomerCardDetailsFormType,
    customerCardPreferenceDefaultValues,
    CustomerCardPreferencesFormType,
} from "./steps/formType";

export type CustomerCardFormType = Omit<
    MyBrokerApi.CustomerCardRequest,
    "personal" | "identity" | "driverLicense" | "preferences" | "authorization" | "officeCommunication"
> &
    CustomerCardDetailsFormType & {
        preferences?: CustomerCardPreferencesFormType;
        authorization?: CustomerCardAuthorizationFormType;
        officeCommunication?: CustomerCardCommunicationFormType;
    };

export const customerCardDefaultValues = (
    policyholderId: number,
    accessRightsId: number,
    policyholderLinked: string,
    policyholderDetails: MyBrokerApi.PolicyHolderPersonalDetails,
    address: MyBrokerApi.AddressChangeRequest,
): CustomerCardFormType => {
    const { isPhysicalPerson, currentDetails } = policyholderDetails;
    return {
        policyholderId,
        accessRightsId,
        policyholderLinked,
        isPhysicalPerson,
        ...customerCardDetailsDefaultValues(policyholderDetails, address),
        authorization: customerCardAuthorizationDefaultValues(),
        preferences: customerCardPreferenceDefaultValues(currentDetails),
        officeCommunication: customerCardCommunicationDefaultValues(currentDetails),
    };
};

export const customerCardMapper = (data: CustomerCardFormType): MyBrokerApi.CustomerCardRequest => {
    const { identity, driverLicense, authorization, preferences, ...rest } = data;
    const { giveAuthorizationPermission, selectedMandate, selectedContracts, contractType, ...restAuthorization } =
        authorization;
    const { medicalWarningBypassed, ...restPreferences } = preferences;

    let customerCard: MyBrokerApi.CustomerCardRequest = {
        ...rest,
        authorization: restAuthorization,
        preferences: restPreferences,
    };

    if (rest.isPhysicalPerson) {
        customerCard = {
            ...customerCard,
            identity,
            driverLicense,
        };
    }
    return customerCard;
};
